import React from "react"
import { ToggleMenu } from './utils/MenuFunctions'

const toggle = (props) => {
	return (
		<div className="toggle" role="button" aria-label="Toggle menu" tabIndex="0" onClick={() => ToggleMenu()} onKeyDown={() => ToggleMenu()}><span></span></div>
	)
}

export default toggle;